/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const CodeIcon = /*#__PURE__*/ createSvgIcon(
  'CodeIcon',
  {
    ltr: {
      large: ({ id }) => (
        <>
          <path
            d="M4.125 10l3.417 3.417a.729.729 0 010 1.062.73.73 0 01-1.07-.007l-3.951-3.951a.756.756 0 01-.208-.525c0-.1.017-.194.052-.281a.691.691 0 01.156-.236l3.958-3.958a.733.733 0 011.063 0 .733.733 0 010 1.062L4.125 10zm11.75 0l-3.417-3.417a.73.73 0 010-1.062.73.73 0 011.07.007l3.951 3.951a.756.756 0 01.208.525c0 .1-.017.194-.052.281a.69.69 0 01-.156.236l-3.958 3.958a.663.663 0 01-.517.219.761.761 0 01-.525-.24.733.733 0 010-1.062L15.875 10z"
            fill="currentColor"
          />
        </>
      ),
    },
  },
  false
);

export default CodeIcon;
